<ng-container *ngIf="vm$ | async as vm">
  <mg-portal-layout-header *ngIf="vm.isMobile && vm.mobileProgress === 'assign'">
    <div
      class="mobile-assigment-header"
      fxLayout="row"
      fxLayoutAlign="center center">
      <mg-text
        variant="header-xl-secondary"
        textAlign="center"
        >{{ MESSAGES.MOBILE_ASSIGNMENT_TITLE }}</mg-text
      >
      <mg-btn
        size="large"
        variant="icon-secondary"
        iconSet="minga"
        icon="mg-cross"
        (pressed)="setMobileProgress('select')"></mg-btn>
    </div>
  </mg-portal-layout-header>

  <mg-portal-layout-footer *ngIf="vm.isMobile">
    <div
      *ngIf="vm.mobileProgress === 'select'"
      class="mobile-btn-wrap">
      <mg-btn
        [disabled]="form.get(FORM_FIELDS.SELECTED_STUDENTS).value.length === 0"
        [wide]="true"
        (pressed)="setMobileProgress('assign')">
        {{ MESSAGES.PROGRESS_NEXT }}
      </mg-btn>
    </div>

    <mg-tt-assignment-footer
      *ngIf="vm.mobileProgress === 'assign'"
      [form]="form"
      [formState]="vm.formState"
      [formErrors]="vm.formErrors"
      [assignSuccess$]="assignSuccess$"
      (assign)="assign()">
      <mg-btn
        secondary-action
        *ngIf="isFlexCheckInAction(form.get(FORM_FIELDS.SELECTED_ACTION).value)"
        variant="outlined"
        class="cancel-btn"
        [id]="
          'tools-myclass-click-secondary-action-' +
          (form.get(FORM_FIELDS.SELECTED_ACTION).value?.assignmentType || 'action')
        "
        [wide]="true"
        iconSet="minga"
        (pressed)="assign({
            isTardyCheckIn: true,
          })">
        {{ MESSAGES.CONTINUE_CHECK_IN_TARDY }}
      </mg-btn>
    </mg-tt-assignment-footer>
  </mg-portal-layout-footer>

  <section
    class="my-class full-width-layout"
    fxLayout="column"
    fxLayoutGap="16px"
    fxLayout.gt-sm="row">
    <div
      *ngIf="vm.formState === 'loading'"
      class="my-class-loading">
      <mg-spinner></mg-spinner>
    </div>

    <div
      *ngIf="vm.formState !== 'loading'"
      class="my-class-main"
      [ngClass]="'layout-' + form.get(FORM_FIELDS.PAGE_LAYOUT).value"
      fxLayout="column"
      fxLayoutGap="8px">
      <div class="my-class-main-filters">
        <ng-container *ngIf="vm.isMobile">
          <mg-collapsible
            [style.display]="vm.mobileProgress === 'assign' ? 'none' : 'block'"
            [collapseText]="MESSAGES.HIDE_TOOLBAR"
            [expandText]="MESSAGES.SHOW_TOOLBAR">
            <mg-tt-filters
              [form]="form"
              [searchingAllStudents]="vm.searchingAllStudents"
              [formState]="vm.formState"
              [totalNumberOfInClassStudents]="vm.studentsWithoutHallpass?.length"
              [selectedNumberOfStudents]="form.get(FORM_FIELDS.SELECTED_STUDENTS).value.length"
              (userListChanged)="userListChanged($event)"
              (selectRandom)="selectRandom(vm.studentsWithoutHallpass)"
              (toggleSelectAll)="toggleSelectAll(vm.studentsWithoutHallpass)"></mg-tt-filters>
          </mg-collapsible>
        </ng-container>
        <ng-container *ngIf="!vm.isMobile">
          <mg-tt-filters
            [form]="form"
            [searchingAllStudents]="vm.searchingAllStudents"
            [formState]="vm.formState"
            [totalNumberOfInClassStudents]="vm.studentsWithoutHallpass?.length"
            [selectedNumberOfStudents]="form.get(FORM_FIELDS.SELECTED_STUDENTS).value.length"
            (userListChanged)="userListChanged($event)"
            (selectRandom)="selectRandom(vm.studentsWithoutHallpass)"
            (toggleSelectAll)="toggleSelectAll(vm.studentsWithoutHallpass)"></mg-tt-filters>
        </ng-container>
      </div>

      <div
        class="my-class-main-students"
        [ngClass]="{ 
          'tw-pb-4': vm.isMobile,
          'tw-hidden': vm.mobileProgress === 'assign' && vm.isMobile,
        }">
        <div
          *ngIf="vm.fetchingStudents"
          class="my-class-main-loading">
          <mg-spinner></mg-spinner>
        </div>

        <ng-container *ngIf="!vm.fetchingStudents">
          <ng-container *ngIf="form.get(FORM_FIELDS.LIST_FILTER).value.length > 0; else noListsTemplate">
            <ng-container *ngIf="vm.studentsWithHallpass?.length > 0 && vm.studentsFromEntireSchool?.length === 0">
              <div class="group-header tw-flex tw-flex-row tw-mb-1">
                <mg-icon>mg-away</mg-icon>
                <mg-text variant="header-md-secondary">
                  {{ MESSAGES.HEADER_OUT_OF_CLASS }}
                </mg-text>
              </div>

              <ng-container
                [ngTemplateOutlet]="studentListTemplate"
                [ngTemplateOutletContext]="{
                  vm: vm,
                  students: vm.studentsWithHallpass,
                  hidePicture: form.get(FORM_FIELDS.HIDE_PICTURE_FILTER).value,
                }">
              </ng-container>
            </ng-container>

            <div class="group-header tw-flex tw-flex-row tw-mb-1">
              <mg-icon>mg-sit</mg-icon>
              <mg-text variant="header-md-secondary">
                {{ MESSAGES.HEADER_IN_CLASS }}
              </mg-text>
            </div>

            <ng-container *ngIf="vm.studentsWithoutHallpass?.length > 0; else noUsersTemplate">
              <ng-container
                [ngTemplateOutlet]="studentListTemplate"
                [ngTemplateOutletContext]="{ 
                  vm: vm, 
                  students: vm.studentsWithoutHallpass ,
                  hidePicture: form.get(FORM_FIELDS.HIDE_PICTURE_FILTER).value,
                  canSort: true,
                }">
              </ng-container>
            </ng-container>

            <ng-container *ngIf="vm.studentsFromEntireSchool?.length > 0">
              <div class="group-header tw-flex tw-flex-row tw-mb-1">
                <mg-icon>mg-away</mg-icon>
                <mg-text variant="header-md-secondary">
                  {{ MESSAGES.HEADER_ENTIRE_SCHOOL }}
                </mg-text>
              </div>

              <ng-container
                [ngTemplateOutlet]="studentListTemplate"
                [ngTemplateOutletContext]="{
                  vm: vm,
                  students: vm.studentsFromEntireSchool,
                  canViewProfile: 'MINGA_PEOPLE_MANAGE' | hasPermission,
                  hidePicture: true
                }">
              </ng-container>
            </ng-container>

            <ng-template #noUsersTemplate>
              <mg-empty-state
                class="tw-mb-4"
                [title]="MESSAGES.NO_USERS_FOUND_TITLE"
                [subtitle]="MESSAGES.NO_USERS_FOUND_SUBTITLE"></mg-empty-state>
            </ng-template>
          </ng-container>

          <ng-template #noListsTemplate>
            <mg-empty-state
              *ngIf="form.get(FORM_FIELDS.LIST_FILTER).value.length === 0"
              class="tw-mb-4"
              [title]="
                vm.listOptions?.length > 0 ? MESSAGES.NO_USER_LIST_SELECTED_TITLE : MESSAGES.NO_USER_LIST_FOUND_TITLE
              "
              [subtitle]="
                vm.listOptions?.length > 0
                  ? MESSAGES.NO_USER_LIST_SELECTED_SUBTITLE
                  : MESSAGES.NO_USER_LIST_FOUND_SUBTITLE
              "
              [actionButtonLabel]="MESSAGES.EMPTY_LIST_ACTION_BUTTON"
              (handleAction)="createUserList()"></mg-empty-state>
          </ng-template>
        </ng-container>
      </div>
    </div>

    <div
      *ngIf="(vm.mobileProgress === 'assign' && vm.isMobile) || !vm.isMobile"
      class="my-class-sidebar"
      [ngClass]="{
        'tw-pb-4': vm.isMobile,
      }">
      <mg-my-class-sidebar
        *ngIf="vm.formState !== 'loading'"
        [actionGroups]="vm.actionGroups"
        [form]="form"
        (assign)="assign()">
        <mg-tt-assignment-footer
          *ngIf="!vm.isMobile"
          [form]="form"
          [formState]="vm.formState"
          [formErrors]="vm.formErrors"
          [assignSuccess$]="assignSuccess$"
          (assign)="assign()">
          <mg-btn
            secondary-action
            *ngIf="isFlexCheckInAction(form.get(FORM_FIELDS.SELECTED_ACTION).value)"
            variant="outlined"
            class="cancel-btn"
            [id]="
              'tools-myclass-click-secondary-action-' +
              (form.get(FORM_FIELDS.SELECTED_ACTION).value?.assignmentType || 'action')
            "
            [wide]="true"
            iconSet="minga"
            (pressed)="assign({
                isTardyCheckIn: true,
              })">
            {{ MESSAGES.CONTINUE_CHECK_IN_TARDY }}
          </mg-btn>
        </mg-tt-assignment-footer>
      </mg-my-class-sidebar>
    </div>
  </section>

  <ng-template
    #studentListTemplate
    let-vm="vm"
    let-students="students"
    let-canViewProfile="canViewProfile"
    let-hidePicture="hidePicture"
    let-canSort="canSort">
    <div
      class="my-class-student-cards tw-mb-4"
      [ngClass]="{
        'no-avatar': hidePicture
      }">
      <ng-container
        [ngTemplateOutlet]="listHeaderTemplate"
        [ngTemplateOutletContext]="{ vm: vm, hidePicture: hidePicture }">
      </ng-container>
      <div
        #studentCard
        *ngFor="
          let student of students
            | studentSort
              : form.get(FORM_FIELDS.SORT_COLUMN).value
              : form.get(FORM_FIELDS.SORT_DIRECTION).value
              : vm.pastAssignments
              : vm.upcomingFlexActivityByStudent;
          trackBy: trackByFn;
          let first = first
        "
        [attr.data-hash]="student.personHash">
        <mg-tt-student-card
          *ngIf="form.get(FORM_FIELDS.PAGE_LAYOUT).value === 'grid' || (mediaService.isMobileView$ | async) === true"
          [canViewProfile]="canViewProfile ?? vm.canViewProfile"
          [authHash]="vm.authHash"
          [selected]="isStudentSelected(form.get(FORM_FIELDS.SELECTED_STUDENTS).value, student)"
          [showPulse]="vm.randomizer === student.personHash"
          [student]="student"
          [hidePicture]="hidePicture"
          [firstNameFirst]="form.get(FORM_FIELDS.SORT_COLUMN).value === 'firstName'"
          [pastAssignments]="vm.pastAssignments?.get(student.personHash) || []"
          [praisesAssigned]="vm.pastAssignments | areActionsAssigned: 'praise'"
          [guidancesAssigned]="vm.pastAssignments | areActionsAssigned: 'guidance'"
          [hallPass]="vm.hallPassesByStudent?.get(student.personHash)"
          [upcomingFlexActivity]="vm.upcomingFlexActivityByStudent?.get(student.personHash)"
          [upcomingPeriod]="vm.upcomingPeriod"
          [showFlexTime]="form.get(FORM_FIELDS.SHOW_FLEXTIME).value"
          [showCheckIn]="form.get(FORM_FIELDS.SHOW_CHECK_IN).value"
          [showBehaviors]="form.get(FORM_FIELDS.SHOW_BEHAVIORS).value"
          (toggleSelected)="toggleSelected($event, student)"
          (hallPassChange)="onHallPassChange($event)"
          (flexRegistration)="onFlexRegistration($event)"
          (sortUpdated)="onSortChanged($event)">
        </mg-tt-student-card>

        <mg-tt-student-list-item
          *ngIf="form.get(FORM_FIELDS.PAGE_LAYOUT).value === 'list' && (mediaService.isMobileView$ | async) === false"
          [canViewProfile]="canViewProfile ?? vm.canViewProfile"
          [authHash]="vm.authHash"
          [selected]="isStudentSelected(form.get(FORM_FIELDS.SELECTED_STUDENTS).value, student)"
          [showPulse]="vm.randomizer === student.personHash"
          [student]="student"
          [hidePicture]="hidePicture ?? vm.hidePicture"
          [firstNameFirst]="form.get(FORM_FIELDS.SORT_COLUMN).value === 'firstName'"
          [pastAssignments]="vm.pastAssignments?.get(student.personHash) || []"
          [praisesAssigned]="vm.pastAssignments | areActionsAssigned: 'praise'"
          [guidancesAssigned]="vm.pastAssignments | areActionsAssigned: 'guidance'"
          [hallPass]="vm.hallPassesByStudent?.get(student.personHash)"
          [addSortHeaders]="first && canSort"
          [upcomingFlexActivity]="vm.upcomingFlexActivityByStudent?.get(student.personHash)"
          [upcomingPeriod]="vm.upcomingPeriod"
          [showFlexTime]="form.get(FORM_FIELDS.SHOW_FLEXTIME).value"
          [showCheckIn]="form.get(FORM_FIELDS.SHOW_CHECK_IN).value"
          [showBehaviors]="form.get(FORM_FIELDS.SHOW_BEHAVIORS).value"
          (toggleSelected)="toggleSelected($event, student)"
          (hallPassChange)="onHallPassChange($event)"
          (flexRegistration)="onFlexRegistration($event)"
          (sortUpdated)="onSortChanged($event)">
        </mg-tt-student-list-item>
      </div>
    </div>
  </ng-template>
</ng-container>

<!-- List Header Template -->
<ng-template
  #listHeaderTemplate
  let-vm="vm"
  let-hidePicture="hidePicture">
  <div
    *ngIf="form.get(FORM_FIELDS.PAGE_LAYOUT).value === 'list' && (mediaService.isMobileView$ | async) === false"
    class="list-row tw-flex tw-items-center tw-gap-3">
    <div class="checkbox-column"></div>

    <div
      *ngIf="hidePicture === false"
      class="avatar-column"></div>

    <div class="first-name-column">
      <mg-sort-arrow
        columnKey="firstName"
        [activeColumnKey]="activeSortColumn$ | async"
        [sortDirection]="
          form.get(FORM_FIELDS.SORT_COLUMN).value === 'firstName' ? form.get(FORM_FIELDS.SORT_DIRECTION).value : null
        "
        (sortChanged)="onSortChanged($event)">
      </mg-sort-arrow>
    </div>

    <div class="last-name-column">
      <mg-sort-arrow
        columnKey="lastName"
        [activeColumnKey]="activeSortColumn$ | async"
        [sortDirection]="
          form.get(FORM_FIELDS.SORT_COLUMN).value === 'lastName' ? form.get(FORM_FIELDS.SORT_DIRECTION).value : null
        "
        (sortChanged)="onSortChanged($event)">
      </mg-sort-arrow>
    </div>

    <div class="tw-flex tw-items-center tw-grow tw-gap-0.5">
      <div class="spacer-column"></div>
      <div class="hallpass-column tw-flex tw-items-center tw-gap-1"></div>

      <div
        *ngIf="form.get(FORM_FIELDS.SHOW_CHECK_IN).value"
        class="checkin-column tw-flex">
        <mg-sort-arrow
          columnKey="checkinPill"
          [activeColumnKey]="activeSortColumn$ | async"
          [sortDirection]="
            form.get(FORM_FIELDS.SORT_COLUMN).value === 'checkinPill'
              ? form.get(FORM_FIELDS.SORT_DIRECTION).value
              : null
          "
          (sortChanged)="onSortChanged($event)">
        </mg-sort-arrow>
      </div>

      <div
        *ngIf="form.get(FORM_FIELDS.SHOW_FLEXTIME).value"
        class="flextime-pill-column tw-flex">
        <mg-sort-arrow
          columnKey="flextimePill"
          [activeColumnKey]="activeSortColumn$ | async"
          [sortDirection]="
            form.get(FORM_FIELDS.SORT_COLUMN).value === 'flextimePill'
              ? form.get(FORM_FIELDS.SORT_DIRECTION).value
              : null
          "
          (sortChanged)="onSortChanged($event)">
        </mg-sort-arrow>
      </div>

      <div
        *ngIf="form.get(FORM_FIELDS.SHOW_FLEXTIME).value"
        class="flextime-name-column tw-flex">
        <mg-sort-arrow
          columnKey="flextimeName"
          [activeColumnKey]="activeSortColumn$ | async"
          [sortDirection]="
            form.get(FORM_FIELDS.SORT_COLUMN).value === 'flextimeName'
              ? form.get(FORM_FIELDS.SORT_DIRECTION).value
              : null
          "
          (sortChanged)="onSortChanged($event)">
        </mg-sort-arrow>
      </div>

      <div
        *ngIf="form.get(FORM_FIELDS.SHOW_BEHAVIORS).value && vm.pastAssignments | areActionsAssigned: 'praise'"
        class="praise-column tw-flex">
        <mg-sort-arrow
          columnKey="praisePill"
          [activeColumnKey]="activeSortColumn$ | async"
          [sortDirection]="
            form.get(FORM_FIELDS.SORT_COLUMN).value === 'praisePill' ? form.get(FORM_FIELDS.SORT_DIRECTION).value : null
          "
          (sortChanged)="onSortChanged($event)">
        </mg-sort-arrow>
      </div>
      <div
        *ngIf="form.get(FORM_FIELDS.SHOW_BEHAVIORS).value && vm.pastAssignments | areActionsAssigned: 'guidance'"
        class="guidance-column tw-flex">
        <mg-sort-arrow
          columnKey="guidancePill"
          [activeColumnKey]="activeSortColumn$ | async"
          [sortDirection]="
            form.get(FORM_FIELDS.SORT_COLUMN).value === 'guidancePill'
              ? form.get(FORM_FIELDS.SORT_DIRECTION).value
              : null
          "
          (sortChanged)="onSortChanged($event)">
        </mg-sort-arrow>
      </div>

      <div class="profile-column"></div>
    </div>
  </div>
</ng-template>
